import { useShallow } from 'zustand/react/shallow';
import { lazy, Suspense } from 'react';
import cn from 'clsx';
import { useMapVisibilityStore } from '@pkgs/components/providers/MapVisibilityStoreProvider';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';

import styles from './SearchResults.module.css';

const MapViewer = lazy(() => import('../MapViewer/MapViewer'));

const MapFallback = ({ isHiddenOnMobile }: { isHiddenOnMobile?: boolean }) => (
  <div className={cn(styles.mapFallbackWrapper, isHiddenOnMobile && styles.mapFallbackWrapperHiddenOnMobile)}>
    <div className={styles.mapFallbackSkeleton} />
  </div>
);

export const ConditionalMapContainer = ({ isMapModalOpen }: { isMapModalOpen: boolean }) => {
  const { featureFlags } = useAppContext();
  const { hasMounted, isWebGLEnabled, isMapActive } = useMapVisibilityStore(
    useShallow((state) => ({
      hasMounted: state.hasMounted,
      isWebGLEnabled: state.isWebGLEnabled,
      isMapActive: state.isMapActive,
    })),
  );

  if (!featureFlags.isMapEnabled) return null;

  if (!hasMounted) return <MapFallback isHiddenOnMobile />;

  if (!isWebGLEnabled) return null;

  if (isMapActive) {
    return (
      <Suspense fallback={<MapFallback />}>
        <MapViewer isModalOpen={isMapModalOpen} />
      </Suspense>
    );
  }
  return null;
};
